(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 920px)');

  function HpTestimonials(root) {
    this.root = root;
    this.tabs = Array.from(root.querySelectorAll('[data-hp-testimonials-tab-index]'));
    this.panels = Array.from(root.querySelectorAll('[data-hp-testimonials-panel-index]'));
    this.carousels = [];
    this.onTabClick = this.onTabClick.bind(this);
    this.onResize = this.onResize.bind(this);

    this.initCarousels();
    this.initTabs();
    window.addEventListener('resize', this.onResize);
  }

  HpTestimonials.prototype.destroy = function () {
    window.removeEventListener('resize', this.onResize);
    this.tabs.forEach(function (tab) {
      tab.removeEventListener('click', this.onTabClick);
    }, this);
    this.carousels.forEach(function (carousel) {
      carousel.destroy();
    });
    this.carousels = [];
  };

  HpTestimonials.prototype.initTabs = function () {
    var self = this;

    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', self.onTabClick);
    });

    var active = this.root.querySelector('.hp-testimonials__tab--active');
    var index = active ? active.getAttribute('data-hp-testimonials-tab-index') : '0';
    this.activateTab(index);
  };

  HpTestimonials.prototype.onTabClick = function (event) {
    var tab = event.currentTarget;
    var index = tab.getAttribute('data-hp-testimonials-tab-index');
    if (index == null) return;
    this.activateTab(index);
  };

  HpTestimonials.prototype.activateTab = function (index) {
    var indexStr = String(index);

    this.tabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-hp-testimonials-tab-index') === indexStr;
      tab.classList.toggle('hp-testimonials__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-hp-testimonials-panel-index') === indexStr;
      panel.classList.toggle('hp-testimonials__panel--active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
        panel.setAttribute('aria-hidden', 'false');
      } else {
        panel.setAttribute('hidden', '');
        panel.setAttribute('aria-hidden', 'true');
      }
    });

    this.carousels.forEach(function (carousel) {
      if (carousel.panel.getAttribute('data-hp-testimonials-panel-index') === indexStr) {
        carousel.refresh();
      } else {
        carousel.disable();
      }
    });
  };

  HpTestimonials.prototype.initCarousels = function () {
    var self = this;

    this.panels.forEach(function (panel) {
      var carouselEl = panel.querySelector('[data-hp-testimonials-carousel]');
      if (!carouselEl) return;
      self.carousels.push(new HpTestimonialsCarousel(carouselEl, panel));
    });
  };

  HpTestimonials.prototype.onResize = function () {
    this.carousels.forEach(function (carousel) {
      carousel.refresh();
    });
  };

  function HpTestimonialsCarousel(root, panel) {
    this.root = root;
    this.panel = panel;
    this.viewport = root.querySelector('[data-hp-testimonials-viewport]');
    this.track = root.querySelector('[data-hp-testimonials-track]');
    this.dotsContainer = root.querySelector('[data-hp-testimonials-dots]');
    this.originalSlides = [];
    this.slideCount = 0;
    this.currentIndex = 0;
    this.isDragging = false;
    this.startX = 0;
    this.deltaX = 0;
    this.enabled = false;

    this.onTransitionEnd = this.onTransitionEnd.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);

    this.track.addEventListener('transitionend', this.onTransitionEnd);
    this.viewport.addEventListener('touchstart', this.onTouchStart, { passive: true });
    this.viewport.addEventListener('touchmove', this.onTouchMove, { passive: false });
    this.viewport.addEventListener('touchend', this.onTouchEnd);
    this.viewport.addEventListener('pointerdown', this.onPointerDown);
    this.viewport.addEventListener('pointermove', this.onPointerMove);
    this.viewport.addEventListener('pointerup', this.onPointerUp);
    this.viewport.addEventListener('pointercancel', this.onPointerUp);
  }

  HpTestimonialsCarousel.prototype.destroy = function () {
    this.disable();
    this.track.removeEventListener('transitionend', this.onTransitionEnd);
    this.viewport.removeEventListener('touchstart', this.onTouchStart);
    this.viewport.removeEventListener('touchmove', this.onTouchMove);
    this.viewport.removeEventListener('touchend', this.onTouchEnd);
    this.viewport.removeEventListener('pointerdown', this.onPointerDown);
    this.viewport.removeEventListener('pointermove', this.onPointerMove);
    this.viewport.removeEventListener('pointerup', this.onPointerUp);
    this.viewport.removeEventListener('pointercancel', this.onPointerUp);
    this.resetDom();
  };

  HpTestimonialsCarousel.prototype.getHeightMode = function () {
    var container = this.root.closest('[data-hp-testimonials]');
    if (!container) return 'equal';
    return container.getAttribute('data-hp-testimonials-height') || 'equal';
  };

  HpTestimonialsCarousel.prototype.clearEqualHeights = function () {
    var slides = this.track.querySelectorAll('.hp-testimonials__slide');
    slides.forEach(function (slide) {
      slide.style.removeProperty('min-height');
      slide.style.removeProperty('height');
      var card = slide.querySelector('.hp-testimonials__card');
      if (card) {
        card.style.removeProperty('min-height');
        card.style.removeProperty('height');
      }
    });
  };

  HpTestimonialsCarousel.prototype.equalizeHeights = function () {
    this.clearEqualHeights();

    if (this.getHeightMode() !== 'equal') return;
    if (!this.enabled || this.originalSlides.length === 0) return;

    var maxHeight = 0;
    this.originalSlides.forEach(function (slide) {
      var card = slide.querySelector('.hp-testimonials__card');
      var height = card ? card.offsetHeight : slide.offsetHeight;
      if (height > maxHeight) maxHeight = height;
    });

    if (maxHeight <= 0) return;

    var slides = this.track.querySelectorAll('.hp-testimonials__slide');
    slides.forEach(function (slide) {
      slide.style.minHeight = maxHeight + 'px';
      var card = slide.querySelector('.hp-testimonials__card');
      if (card) {
        card.style.minHeight = maxHeight + 'px';
      }
    });
  };

  HpTestimonialsCarousel.prototype.resetDom = function () {
    this.clearEqualHeights();

    var clones = this.track.querySelectorAll('[data-hp-testimonials-clone]');
    clones.forEach(function (clone) {
      clone.remove();
    });

    this.originalSlides.forEach(function (slide) {
      slide.style.removeProperty('flex');
      slide.style.removeProperty('width');
    });

    this.track.classList.remove('hp-testimonials__track--no-transition');
    this.track.style.removeProperty('transform');
    this.dotsContainer.innerHTML = '';
    this.originalSlides = [];
    this.slideCount = 0;
    this.currentIndex = 0;
  };

  HpTestimonialsCarousel.prototype.refresh = function () {
    var shouldEnable =
      MOBILE_MQ.matches && this.panel.classList.contains('hp-testimonials__panel--active');

    if (!shouldEnable) {
      this.disable();
      return;
    }

    if (!this.enabled) {
      this.enable();
    } else {
      var self = this;
      this.goTo(this.currentIndex, false);
      this.updateDots();
      requestAnimationFrame(function () {
        self.equalizeHeights();
      });
    }
  };

  HpTestimonialsCarousel.prototype.enable = function () {
    this.resetDom();
    this.originalSlides = Array.from(
      this.track.querySelectorAll('.hp-testimonials__slide:not([data-hp-testimonials-clone])')
    );
    this.slideCount = this.originalSlides.length;

    var self = this;

    if (this.slideCount <= 1) {
      this.buildDots();
      this.enabled = true;
      requestAnimationFrame(function () {
        self.equalizeHeights();
      });
      return;
    }

    var firstClone = this.originalSlides[0].cloneNode(true);
    var lastClone = this.originalSlides[this.slideCount - 1].cloneNode(true);
    firstClone.setAttribute('data-hp-testimonials-clone', 'first');
    lastClone.setAttribute('data-hp-testimonials-clone', 'last');
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');

    this.track.insertBefore(lastClone, this.originalSlides[0]);
    this.track.appendChild(firstClone);

    this.currentIndex = 1;
    this.enabled = true;
    this.buildDots();
    this.goTo(this.currentIndex, false);
    requestAnimationFrame(function () {
      self.equalizeHeights();
    });
  };

  HpTestimonialsCarousel.prototype.disable = function () {
    if (!this.enabled && this.originalSlides.length === 0) return;
    this.enabled = false;
    this.resetDom();
  };

  HpTestimonialsCarousel.prototype.buildDots = function () {
    var self = this;
    this.dotsContainer.innerHTML = '';

    if (this.slideCount <= 1) {
      this.dotsContainer.setAttribute('hidden', '');
      return;
    }

    this.dotsContainer.removeAttribute('hidden');

    for (var i = 0; i < this.slideCount; i += 1) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'hp-testimonials__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.dataset.index = String(i);
      dot.addEventListener('click', function () {
        var target = parseInt(this.dataset.index, 10);
        self.goTo(target + 1, true);
      });
      this.dotsContainer.appendChild(dot);
    }

    this.updateDots();
  };

  HpTestimonialsCarousel.prototype.getRealIndex = function () {
    if (this.slideCount <= 1) return 0;
    if (this.currentIndex === 0) return this.slideCount - 1;
    if (this.currentIndex === this.slideCount + 1) return 0;
    return this.currentIndex - 1;
  };

  HpTestimonialsCarousel.prototype.updateDots = function () {
    var realIndex = this.getRealIndex();
    var dots = this.dotsContainer.querySelectorAll('.hp-testimonials__dot');
    dots.forEach(function (dot, index) {
      dot.classList.toggle('hp-testimonials__dot--active', index === realIndex);
    });
  };

  HpTestimonialsCarousel.prototype.goTo = function (index, animate) {
    if (this.slideCount <= 1) return;

    this.currentIndex = index;
    var offset = -index * 100;

    if (!animate) {
      this.track.classList.add('hp-testimonials__track--no-transition');
    }

    this.track.style.transform = 'translate3d(' + offset + '%, 0, 0)';

    if (!animate) {
      requestAnimationFrame(
        function () {
          this.track.classList.remove('hp-testimonials__track--no-transition');
        }.bind(this)
      );
    }

    this.updateDots();
  };

  HpTestimonialsCarousel.prototype.onTransitionEnd = function (event) {
    if (event.target !== this.track || this.slideCount <= 1) return;

    if (this.currentIndex === 0) {
      this.goTo(this.slideCount, false);
    } else if (this.currentIndex === this.slideCount + 1) {
      this.goTo(1, false);
    }
  };

  HpTestimonialsCarousel.prototype.onTouchStart = function (event) {
    if (!this.enabled || this.slideCount <= 1) return;
    this.startX = event.touches[0].clientX;
    this.deltaX = 0;
    this.isDragging = true;
  };

  HpTestimonialsCarousel.prototype.onTouchMove = function (event) {
    if (!this.isDragging) return;
    this.deltaX = event.touches[0].clientX - this.startX;
    if (Math.abs(this.deltaX) > 10) {
      event.preventDefault();
    }
  };

  HpTestimonialsCarousel.prototype.onTouchEnd = function () {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.finishSwipe();
  };

  HpTestimonialsCarousel.prototype.onPointerDown = function (event) {
    if (!this.enabled || this.slideCount <= 1 || event.pointerType === 'touch') return;
    this.startX = event.clientX;
    this.deltaX = 0;
    this.isDragging = true;
    this.viewport.setPointerCapture(event.pointerId);
  };

  HpTestimonialsCarousel.prototype.onPointerMove = function (event) {
    if (!this.isDragging || event.pointerType === 'touch') return;
    this.deltaX = event.clientX - this.startX;
  };

  HpTestimonialsCarousel.prototype.onPointerUp = function (event) {
    if (!this.isDragging || event.pointerType === 'touch') return;
    this.isDragging = false;
    if (this.viewport.hasPointerCapture(event.pointerId)) {
      this.viewport.releasePointerCapture(event.pointerId);
    }
    this.finishSwipe();
  };

  HpTestimonialsCarousel.prototype.finishSwipe = function () {
    var threshold = 50;
    if (this.deltaX <= -threshold) {
      this.goTo(this.currentIndex + 1, true);
    } else if (this.deltaX >= threshold) {
      this.goTo(this.currentIndex - 1, true);
    }
    this.deltaX = 0;
  };

  var instances = new WeakMap();

  function initTestimonials(scope) {
    var roots = (scope || document).querySelectorAll('[data-hp-testimonials]');
    roots.forEach(function (root) {
      if (instances.has(root)) {
        instances.get(root).destroy();
      }
      instances.set(root, new HpTestimonials(root));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTestimonials(document);
    });
  } else {
    initTestimonials(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initTestimonials(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-hp-testimonials]').forEach(function (root) {
      if (instances.has(root)) {
        instances.get(root).destroy();
        instances.delete(root);
      }
    });
  });
})();
